export default "__VITE_ASSET__iXjJAfAp__"